<shared-chat-messages
  [messages]="messages()"
  [messageIdsWithError]="messageIdsWithError()"
  [participant]="participant()"
  [conversationParticipants]="conversationParticipants()"
  [unreadMessages]="participant()?.unreadMessagesCount ?? 0"
  [messageAppendLoading]="messageAppendLoading()"
  [messagePrependLoading]="messagePrependLoading()"
  [conversationAppType]="conversationAppType()"
  [sharedUserDisplayName]="sharedUserDisplayName()"
  [errors]="errors()"
  [windowService]="windowService()"
  #conversationMessages
  (scrolled)="scrolled.emit()"
  (scrolledUp)="scrolledUp.emit()"
  (assetClick)="assetClicked.emit($event)"
  (buttonClick)="messageButtonClicked.emit($event)"
  (messageRead)="messageRead.emit($event)"
  (scrolledToBottom)="scrolledToBottom.emit($event)"
  (resendMessage)="resendMessage.emit($event)"
  (refreshMessages)="refreshMessages.emit()"
  [otherTypingParticipants]="otherTypingParticipants()" />
<shared-conversation-footer
  data-testid="conversation-footer"
  #conversationFooter
  [userId]="userId()"
  [userIsNotParticipant]="userIsNotParticipant()"
  [noUsers]="noUsers()"
  [isConversationLocked]="isConversationLocked()"
  [conversationLockNote]="conversationLockNote()"
  [isConversationArchived]="isConversationArchived()"
  (unlockAction)="unlockAction.emit($event)"
  [conversationId]="conversationId()"
  [templates]="templates()"
  [senderType]="senderType()"
  [loading]="loading()"
  (sendMessage)="sendMessage.emit(footerButtonTypeEnum.Text)"
  [(files)]="files"
  [nextMessageSourceId]="nextMessageSourceId()"
  [messageInputController]="messageInputController() ?? defaultController"
  [conversationParticipants]="conversationParticipants()"
  (isTyping)="sendIsTypingEvent($event)"
  (joinConversation)="joinConversation.emit()" />
